export { default } from './aliyun/getFileSignUrl'
